import React, { useState } from 'react'
import '../App.css'
import { useDispatch } from 'react-redux';
import { addNote } from '../Redux/action';

export default function NotesForm() {
    let [title,setTitle]=useState('')
    let [content,setContent]=useState('')
 
    const dispatch = useDispatch();

   function handleSubmission(e){
    e.preventDefault();
    dispatch(addNote(title,content))
    setTitle('')
    setContent('')
   }
  return (
  <>
  
  <form onSubmit={handleSubmission}>
      <h3><b>Add Notes....</b></h3>
      <hr/>
      <br/>
      <label forName="title"><h5>Title</h5></label><br/>
      <input type='text' name='title' id='title' value={title} placeholder='Enter title' onChange={(e)=>setTitle(e.target.value)} required/><br/><br/>
      <label forName="content"><h5>Content</h5></label><br/>
      <textarea type='text' name='content' value={content} placeholder='Enter Content......' onChange={(e)=> setContent(e.target.value)} required/><br/>
      <hr/>
      <button type='submit' className='button'><b>Click to Add </b><img src='https://icon-library.com/images/add-note-icon/add-note-icon-20.jpg' className='btn-img'/></button>
   </form> 
              
 
  </>
   
  )
}
